// extracted by mini-css-extract-plugin
module.exports = {"back":"playlist_back__3z4i4"};